import React, { Component } from 'react';
import { Route, Link, NavLink, BrowserRouter as Router } from 'react-router-dom'


export class LoginLayout extends Component {
    render(){
        window.setLoginUI()
        return(
            
	<div id="page-container" className="fade">
        <div className="login login-with-news-feed">
            <div className="news-feed">
                <div className="news-image loginImage" ></div>
                <div className="news-caption">
                    <h4 className="caption-title"><b>AASTMT</b> Student Portal</h4>
                    <p>
                    AASTMT Student Portal is an online gateway 
                    where students can log in to access important program information.
                    Student Portal contain information on courses, transcripts, timetables, exam schedules 
                    and department contact numbers.
                    </p>
                </div>
            </div>
            <div className="right-content">
                <div className="login-header">
                    <div className="brand text-center">
                    <img src="/assets/img/logo/logo.png" width="48" alt=""/> <b>Student</b> Portal
                        {/* <small>AASTMT Student's Online Access</small> */}
                    </div>
                    <div className="icon">
                        <i className="fa fa-sign-in"></i>
                    </div>
                </div>
                <div className="login-content">
                    {this.props.children}

                        {!window.location.href.includes("vaccine") &&
                    
                        <div className="m-t-20 m-b-40 p-b-40 text-inverse">
                        Can't log in or Forgot Password? Click <a href="#" onClick={this.props.Forget} className="text-success">here</a> to send your password.
                        </div>
                        }
                        <hr />
                        <p className="text-center text-grey-darker">
                             Copyright &copy; 2019 Information and Documentation Center - AASTMT 

                        </p>
                </div>
            </div>
        </div>
        
        
	</div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/login/LoginLayout.js